export const getWhatsAppCallId = item => {
  const payload = item?.additional_attributes?.whatsapp_call;
  return String(
    item?.provider_call_id ||
      payload?.id ||
      payload?.call_id ||
      payload?.call_context_id ||
      ''
  );
};

const callDirection = call => {
  if (call?.meta?.direction) return call.meta.direction;
  return call?.direction === 'outgoing'
    ? 'BUSINESS_INITIATED'
    : 'USER_INITIATED';
};

const callPayload = call => ({
  ...(call.meta || {}),
  id: call.provider_call_id,
  record_id: call.id,
  call_context_id:
    call.provider_context_id || call.meta?.call_context_id || undefined,
  direction: callDirection(call),
  status: call.meta?.status || call.meta?.state || call.status,
  status_source: call.status_source || call.meta?.status_source,
  from: call.meta?.from || call.from_number,
  to: call.meta?.to || call.to_number,
  termination_source: call.termination_source || call.meta?.termination_source,
  not_answered: call.not_answered,
  not_answered_reason: call.end_reason || call.meta?.not_answered_reason,
  synthetic_termination: call.synthetic_termination,
  call_started_at:
    call.started_at || call.meta?.call_started_at || call.meta?.start_time,
  call_ended_at:
    call.ended_at || call.meta?.call_ended_at || call.meta?.end_time,
  call_duration_seconds:
    call.duration_seconds ?? call.meta?.call_duration_seconds,
  recording: call.recording || undefined,
  status_updated_at: call.last_event_at || call.meta?.status_updated_at,
  initiated_by_user_id:
    call.meta?.initiated_by_user_id || call.initiated_by?.id,
  initiated_by_name:
    call.meta?.initiated_by_name ||
    call.initiated_by?.available_name ||
    call.initiated_by?.name,
  answered_by_user_id: call.meta?.answered_by_user_id || call.answered_by?.id,
  answered_by_name:
    call.meta?.answered_by_name ||
    call.answered_by?.available_name ||
    call.answered_by?.name,
  terminated_by_user_id:
    call.meta?.terminated_by_user_id || call.terminated_by?.id,
  terminated_by_name:
    call.meta?.terminated_by_name ||
    call.terminated_by?.available_name ||
    call.terminated_by?.name,
  rejected_by_user_id: call.meta?.rejected_by_user_id || call.rejected_by?.id,
  rejected_by_name:
    call.meta?.rejected_by_name ||
    call.rejected_by?.available_name ||
    call.rejected_by?.name,
});

export const buildCallTimelineMessage = call => ({
  id: `call-record-${call.id}`,
  call_record_id: call.id,
  is_call_record: true,
  content: null,
  inbox_id: call.inbox_id,
  conversation_id: call.conversation_id,
  message_type: 2,
  content_type: 'text',
  status: 'sent',
  content_attributes: {},
  additional_attributes: { whatsapp_call: callPayload(call) },
  created_at: call.occurred_at,
  updated_at: call.updated_at,
  private: false,
  source_id: `wa_call:${call.provider_call_id}:${call.status}`,
  sender: call.initiated_by || null,
  attachments: [],
});

export const buildRealtimeCallTimelineMessage = message => {
  const callId = getWhatsAppCallId(message);
  if (!callId) return null;

  return {
    ...message,
    id: `call-record-live-${callId}`,
    call_record_id: null,
    is_call_record: true,
  };
};
